import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "src/dist/index.css";
import { Provider } from "react-redux";
import { store } from "common/store";
import { Tracking } from "common/components/Tracking";
import { useServiceWorker } from "common/hooks/useServiceWorker";
import { Toaster } from "react-hot-toast";
import { RemoteStorageProvider } from "common/components/RemoteStorage/RemoteStorageProvider";
import { Outlet } from "react-router";
import { HamburgerMenu } from "common/components/HamburgerMenu";
import { NavigatorListener } from "common/components/Navigator/Listener";
import { NavigatorContextProvider } from "common/components/Navigator/Context";
import { LiveChat } from "src/LiveChat";
import { Spinner } from "common/components/Spinner";
import { isLoading } from "common/selectors/ui.selectors";

export const Root: React.FC<{}> = () => {
  useServiceWorker();
  return (
    <Provider store={store}>
      <Tracking>
        <RemoteStorageProvider>
          <NavigatorContextProvider>
            <LiveChat />
            <Toaster position="top-right" />
            <Outlet />
            <HamburgerMenu />
            <NavigatorListener />
            <Spinner loadingSelector={isLoading} />
          </NavigatorContextProvider>
        </RemoteStorageProvider>
      </Tracking>
    </Provider>
  );
};
